export const NULL_PRICE = 999999;
